import { withStyles } from '@material-ui/core/styles'
import { cpBlueMediumLight, cpBlueMedium } from '@daptiv/ppm-npmp-react-theme/colors'
import Button from '@material-ui/core/Button'

const styles = (theme) => ({
  root: {
    marginLeft: '16px',
    minWidth: '64px',
    borderRadius: '2px',
    paddingLeft: '8px',
    paddingRight: '8px',
    minHeight: '36px',
    color: cpBlueMediumLight[600],
    // Wait for material-ui v1.beta9+ see: https://github.com/callemall/material-ui/issues/8048
    '&:hover': {
      color: cpBlueMedium[600]
    }
  },
  disabled: {
    color: theme.palette.action.disabled
  },
  focusVisible: {
    backgroundColor: theme.palette.grey[100]
  }
})

export default withStyles(styles)(Button)



// WEBPACK FOOTER //
// ./src/components/DialogButton/DialogButton.js